import { useState } from "react"
import DatePicker from "react-datepicker"
import { useTranslation } from "react-i18next"
import moment from "moment"
import CustomTimeInput from "./DateEventField"
import { IconCalendar } from "../../utils/Icons/CustomIcons"
import "react-datepicker/dist/react-datepicker.css"

const DateEvent = ({ event, setEvent, error, handleChange }: any) => {
  const { t } = useTranslation()

  const [startDate, setStartDate] = useState<any>("")
  const [focus, setFocus] = useState(false)

  return (
    <div
      className={
        error
          ? "profile-input input-item datepicker-item input-error"
          : "profile-input datepicker-item input-item"
      }
    >
      <DatePicker
        autoComplete="off"
        selected={startDate}
        minDate={moment().toDate()}
        onChange={(date: any) => {
          handleChange(date)
          setStartDate(date)
          setEvent({ ...event, start_datetime: date })
        }}
        dateFormat={`EEEE d MMM, yyyy, HH:mm`}
        // dateFormat={`EEEE d MMM, yyyy, h:mm aa`} AM & PM
        showTimeInput={true}
        customTimeInput={
          <CustomTimeInput
            date={startDate}
            value={startDate}
            onChange={handleChange}
            setFocus={setFocus}
          />
        }
        onFocus={() => {
          setFocus(true)
        }}
        onClickOutside={() => {
          setFocus(false)
        }}
        showDisabledMonthNavigation
        open={focus}
      />

      <label className={startDate || focus ? "active" : ""} htmlFor="">
        {startDate || focus ? t("onboarding.placeholders.date") : t("onboarding.placeholders.pickDate")}
      </label>

      <IconCalendar className="icon" />

      {error && <span className="input-item__error error mt-1">{error}</span>}
    </div>
  )
}

export default DateEvent
